import { axisFont } from "../text/axisFont";
import { formatPrice } from "../axes/priceFormat";

const isInPane = ({ x, y }, axis, { width, height }) => (axis === "y" ? y >= 0 && y <= height : x >= 0 && x <= width);

/**
 * Labels of the Fibonacci levels (po-chart-visual-spec.md §7.5): one group per
 * side of a drawing, see drawingShapeParts.js. All are drawn, close levels overlap as in PO.
 *
 * @param {object} textLayer
 * @param {object[]} shapes - from resolveShape
 * @param {object} params
 * @param {object} params.priceScale
 * @param {{ width: number, height: number }} params.pane - labels never leave the price pane
 * @param {number} params.decimals - price precision of the pair
 * @param {string} params.fontFamily
 */
export const drawDrawingLevelLabels = (textLayer, shapes, { priceScale, pane, decimals, fontFamily }) => {
  const groups = shapes.flatMap(({ labels }) => labels);

  if (!groups.length) return;

  const { context } = textLayer;
  const font = axisFont(fontFamily);

  context.save();
  context.beginPath();
  context.rect(0, 0, pane.width, pane.height);
  context.clip();

  groups.forEach(({ color, align, axis, entries }) => {
    entries.forEach((entry) => {
      if (!isInPane(entry, axis, pane)) return;

      const text = entry.isPrice ? formatPrice(priceScale.yToPrice(entry.y), decimals) : entry.text;

      textLayer.drawText(text, entry.x, entry.y, { font, color, align });
    });
  });

  context.restore();
};
